import { render, staticRenderFns } from "./godownentry.vue?vue&type=template&id=5db1a37c&scoped=true&"
import script from "./godownentry.vue?vue&type=script&lang=js&"
export * from "./godownentry.vue?vue&type=script&lang=js&"
import style0 from "./godownentry.vue?vue&type=style&index=0&id=5db1a37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1a37c",
  null
  
)

export default component.exports